import { createFileRoute, Outlet } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

import { z } from 'zod'

import { MultiTenantTabs } from '@/features/air/multi-tenant/components/tabs'
import { TenantFilter } from '@/features/air/multi-tenant/components/tenant-filter'
import { multiTenantQueries } from '@/features/air/multi-tenant/queries'
import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { Section, SectionTitle } from '@/features/app-shell/section'

import { userKeys } from '@/shared/auth/queries'

import type { UserRequest } from '@/shared/auth/types'

const searchSchema = z.object({
	tenants: z.array(z.string()).optional(),
	q: z.string().optional(),
	page: z.number().optional(),
})

export const Route = createFileRoute('/_dashboard/multi-tenant/_layout')({
	validateSearch: zodValidator(searchSchema),
	loaderDeps: ({ search }) => ({ tenants: search.tenants, page: search.page }),
	loader: ({ deps, context: { queryClient } }) => {
		const meData = queryClient.getQueryData<UserRequest>(userKeys.me())
		const allTenantIds = (meData?.allowed_tenants ?? []).map((t) => t.id)
		const selected = deps.tenants ?? allTenantIds

		if (selected.length > 0) {
			queryClient.prefetchQuery(
				multiTenantQueries.cases(selected, deps.page ?? 1),
			)
			queryClient.prefetchQuery(multiTenantQueries.policies(selected))
			queryClient.prefetchQuery(multiTenantQueries.automations(selected))
		}
	},
	head: () => ({
		meta: [{ title: 'Multi-Tenant Overview | BitLyft AIR®' }],
	}),
	component: MultiTenantLayout,
	errorComponent: RouteErrorComponent,
})

function MultiTenantLayout() {
	return (
		<Section>
			<div className="flex items-center justify-between">
				<SectionTitle>Tenants Overview</SectionTitle>
				<TenantFilter />
			</div>

			<MultiTenantTabs />

			<Outlet />
		</Section>
	)
}
